import { render, staticRenderFns } from "./settingsTabs.vue?vue&type=template&id=17b321d4&scoped=true&"
import script from "./settingsTabs.vue?vue&type=script&lang=js&"
export * from "./settingsTabs.vue?vue&type=script&lang=js&"
import style0 from "./settingsTabs.vue?vue&type=style&index=0&id=17b321d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b321d4",
  null
  
)

export default component.exports